import { IBeegoAppointment } from '@internal-models/beego-appointment.model';
import { IEvent } from '@internal-models/event.model';

export interface ICalendarEvent {
	id: string;
	startsAt: Date | string;
	endsAt: Date | string;
	Event?: IEvent;
	BeegoAppointment: IBeegoAppointment;
	BeegoAppointmentId: string;
	BeecloudCalendarEvent: IBeecloudCalendarEvent;
	calendarEventType: CalendarEventType;
	reservations?: number;
	reserved?: number;
	distance?: number;
}

export interface IBeecloudCalendarEvent {
	id: string;
	date: string;
	beginTime: string;
	endTime: string;
	distance: string;
	AppointmentId: string;
	WorkBlockId: string;
	WorkBlock: {
		id: string;
		date: string;
		beginTime: string;
		endTime: string;
		Region: {
			RegionAddress: { lat: string; long: string };
		};
		Employee: {
			id: string;
			firstname: string;
			name: string;
			pictureUrl: string;
		};
	};
}

export enum CalendarEventType {
	InternalEvent = 'internal-event',
	BeegoAppointment = 'beego-appointment',
}
